import { forwardRef } from "react";
import { classNames } from 'zeta-dom-react';
import { exclude } from "zeta-dom/util";
import { linkAttr, openWindow } from "src/util/common";
import { ConfirmDialogProps, openConfirmDialog } from '.';

export interface OptionalLinkProps extends React.ComponentPropsWithRef<'a'> {
    dialog?: Omit<ConfirmDialogProps, 'onCommit'>;
    onClick?: any;
}

export const OptionalLink = forwardRef<HTMLElement, OptionalLinkProps>((props, ref) => {
    const { dialog, href, target, className, onClick } = props;

    if (href && !dialog) {
        return (<a ref={ref} {...(props as any)} {...linkAttr(href, target)} onClick={onClick}>{props.children}</a>);
    }
    return (<div ref={ref} {...(exclude(props, ['download', 'href', 'hrefLang', 'media', 'ping', 'rel', 'target', 'type', 'referrerPolicy', 'dialog']) as any)}
        className={classNames(className, { 'eac-clickable': !!dialog })} onClick={dialog ? openDialog : undefined} />);

    function openDialog() {
        openConfirmDialog({
            ...dialog!,
            onCommit(value) {
                if (value && href) {
                    if (linkAttr(href, target).target === '_blank') {
                        openWindow(href);
                    } else {
                        window.location.href = href;
                    }
                }
            }
        });
    }
});
